export const newTagToken = {
  textFontSizeB300: '10px',
  textLineHeightB300: '14px',
  textFontWeightB300: '500',
  textColorPrimary: '#BF8E00',
  boxBorderWidth: '0px',
};

export const toolTipToken = {
  popoverBackgroundColorFill: 'white',
  popoverForegroundColorFill: '#697576',
};

export const sidebarToken = {
  sideMenuBackgroundColorSurface: "#0E2B31",
  sideMenuBackgroundColorPrinciple: "#0E2B31",
  sideMenuBackgroundColorHighlight: "#0E2B31",
  sideMenuBackgroundColorSubdue: "#0E2B31",
  sideMenuLinkBackgroundColorDefault: "#0E2B31",
  sideMenuLinkBackgroundColorHover: "#00A69A",
  sideMenuLinkBackgroundColorPressed: "#00A69A",
  sideMenuLinkBackgroundColorSelected: "#00A69A",
  sideMenuBorderColor: "#00A69A",
  sideMenuLinkForegroundColorDefault: "#FFFFFF",
  sideMenuBorderRadius: "12px",
  sideMenuLinkIndicatorBorderRadius: '12px',
}

export const sidemenuTextColorToken = {
  textColorPrimary: "#FFFFFF",
  sideMenuLinkForegroundColorDefault: '#FFFFFF',
  sideMenuLinkForegroundColorDisabled: "#FFFFFF",
  sideMenuBorderRadius: "12px",
}